/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import PropTypes from "prop-types";
import { useDraggable } from "@dnd-kit/core";
import ExerciseCard from "../exercise/ExerciseCard";

function DraggableExerciseCard({ exercise }) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `exercise-card-${exercise.id}`,
    data: {
      type: "exercise-card",
      exercise,
    },
  });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={{
        cursor: "grab",
        opacity: isDragging ? 0.35 : 1,
      }}
    >
      <ExerciseCard
        exercise={exercise}
        style={{
          opacity: 1, // el card SIEMPRE visible (el div controla el fade)
        }}
      />
    </div>
  );
}

DraggableExerciseCard.propTypes = {
  exercise: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default DraggableExerciseCard;
